import { render } from "./list-role.vue?vue&type=template&id=24b62ccd&scoped=true"
import script from "./list-role.vue?vue&type=script&lang=js"
export * from "./list-role.vue?vue&type=script&lang=js"

import "./list-role.vue?vue&type=style&index=0&id=24b62ccd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b62ccd"]])

export default __exports__